import { SQSServiceException as __BaseException } from "./SQSServiceException";
export class OverLimit extends __BaseException {
    constructor(opts) {
        super({
            name: "OverLimit",
            $fault: "client",
            ...opts,
        });
        this.name = "OverLimit";
        this.$fault = "client";
        Object.setPrototypeOf(this, OverLimit.prototype);
    }
}
export class MessageNotInflight extends __BaseException {
    constructor(opts) {
        super({
            name: "MessageNotInflight",
            $fault: "client",
            ...opts,
        });
        this.name = "MessageNotInflight";
        this.$fault = "client";
        Object.setPrototypeOf(this, MessageNotInflight.prototype);
    }
}
export class ReceiptHandleIsInvalid extends __BaseException {
    constructor(opts) {
        super({
            name: "ReceiptHandleIsInvalid",
            $fault: "client",
            ...opts,
        });
        this.name = "ReceiptHandleIsInvalid";
        this.$fault = "client";
        Object.setPrototypeOf(this, ReceiptHandleIsInvalid.prototype);
    }
}
export class BatchEntryIdsNotDistinct extends __BaseException {
    constructor(opts) {
        super({
            name: "BatchEntryIdsNotDistinct",
            $fault: "client",
            ...opts,
        });
        this.name = "BatchEntryIdsNotDistinct";
        this.$fault = "client";
        Object.setPrototypeOf(this, BatchEntryIdsNotDistinct.prototype);
    }
}
export class EmptyBatchRequest extends __BaseException {
    constructor(opts) {
        super({
            name: "EmptyBatchRequest",
            $fault: "client",
            ...opts,
        });
        this.name = "EmptyBatchRequest";
        this.$fault = "client";
        Object.setPrototypeOf(this, EmptyBatchRequest.prototype);
    }
}
export class InvalidBatchEntryId extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidBatchEntryId",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidBatchEntryId";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidBatchEntryId.prototype);
    }
}
export class TooManyEntriesInBatchRequest extends __BaseException {
    constructor(opts) {
        super({
            name: "TooManyEntriesInBatchRequest",
            $fault: "client",
            ...opts,
        });
        this.name = "TooManyEntriesInBatchRequest";
        this.$fault = "client";
        Object.setPrototypeOf(this, TooManyEntriesInBatchRequest.prototype);
    }
}
export class QueueDeletedRecently extends __BaseException {
    constructor(opts) {
        super({
            name: "QueueDeletedRecently",
            $fault: "client",
            ...opts,
        });
        this.name = "QueueDeletedRecently";
        this.$fault = "client";
        Object.setPrototypeOf(this, QueueDeletedRecently.prototype);
    }
}
export class QueueNameExists extends __BaseException {
    constructor(opts) {
        super({
            name: "QueueNameExists",
            $fault: "client",
            ...opts,
        });
        this.name = "QueueNameExists";
        this.$fault = "client";
        Object.setPrototypeOf(this, QueueNameExists.prototype);
    }
}
export class InvalidIdFormat extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidIdFormat",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidIdFormat";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidIdFormat.prototype);
    }
}
export class InvalidAttributeName extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidAttributeName",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidAttributeName";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidAttributeName.prototype);
    }
}
export class QueueDoesNotExist extends __BaseException {
    constructor(opts) {
        super({
            name: "QueueDoesNotExist",
            $fault: "client",
            ...opts,
        });
        this.name = "QueueDoesNotExist";
        this.$fault = "client";
        Object.setPrototypeOf(this, QueueDoesNotExist.prototype);
    }
}
export class PurgeQueueInProgress extends __BaseException {
    constructor(opts) {
        super({
            name: "PurgeQueueInProgress",
            $fault: "client",
            ...opts,
        });
        this.name = "PurgeQueueInProgress";
        this.$fault = "client";
        Object.setPrototypeOf(this, PurgeQueueInProgress.prototype);
    }
}
export class InvalidMessageContents extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidMessageContents",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidMessageContents";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidMessageContents.prototype);
    }
}
export class UnsupportedOperation extends __BaseException {
    constructor(opts) {
        super({
            name: "UnsupportedOperation",
            $fault: "client",
            ...opts,
        });
        this.name = "UnsupportedOperation";
        this.$fault = "client";
        Object.setPrototypeOf(this, UnsupportedOperation.prototype);
    }
}
export class BatchRequestTooLong extends __BaseException {
    constructor(opts) {
        super({
            name: "BatchRequestTooLong",
            $fault: "client",
            ...opts,
        });
        this.name = "BatchRequestTooLong";
        this.$fault = "client";
        Object.setPrototypeOf(this, BatchRequestTooLong.prototype);
    }
}
export const AddPermissionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ChangeMessageVisibilityRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ChangeMessageVisibilityBatchRequestEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ChangeMessageVisibilityBatchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchResultErrorEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ChangeMessageVisibilityBatchResultEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ChangeMessageVisibilityBatchResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateQueueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateQueueResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMessageBatchRequestEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMessageBatchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMessageBatchResultEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteMessageBatchResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteQueueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQueueAttributesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQueueAttributesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQueueUrlRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetQueueUrlResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDeadLetterSourceQueuesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListDeadLetterSourceQueuesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListQueuesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListQueuesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListQueueTagsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListQueueTagsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PurgeQueueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReceiveMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MessageAttributeValueFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MessageFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ReceiveMessageResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RemovePermissionRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const MessageSystemAttributeValueFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageBatchRequestEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageBatchRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageBatchResultEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SendMessageBatchResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SetQueueAttributesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagQueueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagQueueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
